// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file public/v1/public_api.proto (package public_api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Empty, EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Gateway } from "../../common/v1/gateway_pb";
import { file_common_v1_gateway } from "../../common/v1/gateway_pb";
import type { Address, BillingAddress } from "../../common/v1/address_pb";
import { file_common_v1_address } from "../../common/v1/address_pb";
import type { NotificationEvent, NotificationGroupHowOften, PushNotificationDeviceToken } from "../../common/v1/push_notifications_pb";
import { file_common_v1_push_notifications } from "../../common/v1/push_notifications_pb";
import type { Audiobook as Audiobook$1 } from "../../dashboard/v1/audiobooks_pb";
import { file_dashboard_v1_audiobooks } from "../../dashboard/v1/audiobooks_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file public/v1/public_api.proto.
 */
export const file_public_v1_public_api: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_common_v1_gateway, file_common_v1_address, file_common_v1_push_notifications, file_google_protobuf_empty, file_dashboard_v1_audiobooks]);

/**
 * @generated from message public_api.v1.IsOneClickPaymentAvailableRequest
 */
export type IsOneClickPaymentAvailableRequest = Message<"public_api.v1.IsOneClickPaymentAvailableRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message public_api.v1.IsOneClickPaymentAvailableRequest.
 * Use `create(IsOneClickPaymentAvailableRequestSchema)` to create a new message.
 */
export const IsOneClickPaymentAvailableRequestSchema: GenMessage<IsOneClickPaymentAvailableRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 0);

/**
 * @generated from message public_api.v1.IsOneClickPaymentAvailableResponse
 */
export type IsOneClickPaymentAvailableResponse = Message<"public_api.v1.IsOneClickPaymentAvailableResponse"> & {
  /**
   * @generated from field: bool inpost_pay = 1;
   */
  inpostPay: boolean;

  /**
   * @generated from field: bool apple_pay = 2;
   */
  applePay: boolean;

  /**
   * @generated from field: bool google_pay = 3;
   */
  googlePay: boolean;

  /**
   * @generated from field: optional public_api.v1.IsOneClickPaymentAvailableResponse.GooglePayConfig google_pay_config = 4;
   */
  googlePayConfig?: IsOneClickPaymentAvailableResponse_GooglePayConfig;
};

/**
 * Describes the message public_api.v1.IsOneClickPaymentAvailableResponse.
 * Use `create(IsOneClickPaymentAvailableResponseSchema)` to create a new message.
 */
export const IsOneClickPaymentAvailableResponseSchema: GenMessage<IsOneClickPaymentAvailableResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 1);

/**
 * @generated from message public_api.v1.IsOneClickPaymentAvailableResponse.GooglePayConfig
 */
export type IsOneClickPaymentAvailableResponse_GooglePayConfig = Message<"public_api.v1.IsOneClickPaymentAvailableResponse.GooglePayConfig"> & {
  /**
   * @generated from field: string merchant_id = 1;
   */
  merchantId: string;

  /**
   * @generated from field: string merchant_name = 2;
   */
  merchantName: string;

  /**
   * @generated from field: string gateway = 3;
   */
  gateway: string;

  /**
   * @generated from field: string gateway_merchant_id = 4;
   */
  gatewayMerchantId: string;
};

/**
 * Describes the message public_api.v1.IsOneClickPaymentAvailableResponse.GooglePayConfig.
 * Use `create(IsOneClickPaymentAvailableResponse_GooglePayConfigSchema)` to create a new message.
 */
export const IsOneClickPaymentAvailableResponse_GooglePayConfigSchema: GenMessage<IsOneClickPaymentAvailableResponse_GooglePayConfig> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 1, 0);

/**
 * @generated from message public_api.v1.OneClickAuthorizePaymentRequest
 */
export type OneClickAuthorizePaymentRequest = Message<"public_api.v1.OneClickAuthorizePaymentRequest"> & {
  /**
   * @generated from field: public_api.v1.OneClickAuthorizePaymentRequest.Gateway gateway = 1;
   */
  gateway: OneClickAuthorizePaymentRequest_Gateway;

  /**
   * @generated from field: string paymentData = 2;
   */
  paymentData: string;

  /**
   * @generated from field: string paymentMethod = 3;
   */
  paymentMethod: string;

  /**
   * @generated from field: string transactionIdentifier = 4;
   */
  transactionIdentifier: string;

  /**
   * @generated from field: public_api.v1.GetPreOrderDetailsRequest order = 5;
   */
  order?: GetPreOrderDetailsRequest;

  /**
   * @generated from field: optional common.v1.Address shipping_address = 6;
   */
  shippingAddress?: Address;

  /**
   * @generated from field: optional common.v1.BillingAddress billing_address = 7;
   */
  billingAddress?: BillingAddress;

  /**
   * @generated from field: optional string metadata = 8;
   */
  metadata?: string;
};

/**
 * Describes the message public_api.v1.OneClickAuthorizePaymentRequest.
 * Use `create(OneClickAuthorizePaymentRequestSchema)` to create a new message.
 */
export const OneClickAuthorizePaymentRequestSchema: GenMessage<OneClickAuthorizePaymentRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 2);

/**
 * @generated from enum public_api.v1.OneClickAuthorizePaymentRequest.Gateway
 */
export enum OneClickAuthorizePaymentRequest_Gateway {
  /**
   * @generated from enum value: APPLE_PAY = 0;
   */
  APPLE_PAY = 0,

  /**
   * @generated from enum value: GOOGLE_PAY = 1;
   */
  GOOGLE_PAY = 1,
}

/**
 * Describes the enum public_api.v1.OneClickAuthorizePaymentRequest.Gateway.
 */
export const OneClickAuthorizePaymentRequest_GatewaySchema: GenEnum<OneClickAuthorizePaymentRequest_Gateway> = /*@__PURE__*/
  enumDesc(file_public_v1_public_api, 2, 0);

/**
 * @generated from message public_api.v1.OneClickAuthorizePaymentResponse
 */
export type OneClickAuthorizePaymentResponse = Message<"public_api.v1.OneClickAuthorizePaymentResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string redirect_url = 2;
   */
  redirectUrl: string;

  /**
   * @generated from field: string transaction_id = 3;
   */
  transactionId: string;

  /**
   * @generated from field: optional string apple_pay_tracking_url = 4;
   */
  applePayTrackingUrl?: string;
};

/**
 * Describes the message public_api.v1.OneClickAuthorizePaymentResponse.
 * Use `create(OneClickAuthorizePaymentResponseSchema)` to create a new message.
 */
export const OneClickAuthorizePaymentResponseSchema: GenMessage<OneClickAuthorizePaymentResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 3);

/**
 * @generated from message public_api.v1.PreOrderItem
 */
export type PreOrderItem = Message<"public_api.v1.PreOrderItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 quantity = 2;
   */
  quantity: number;
};

/**
 * Describes the message public_api.v1.PreOrderItem.
 * Use `create(PreOrderItemSchema)` to create a new message.
 */
export const PreOrderItemSchema: GenMessage<PreOrderItem> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 4);

/**
 * @generated from message public_api.v1.GetPreOrderDetailsRequest
 */
export type GetPreOrderDetailsRequest = Message<"public_api.v1.GetPreOrderDetailsRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: repeated public_api.v1.PreOrderItem items = 2;
   */
  items: PreOrderItem[];

  /**
   * @generated from field: optional string country_code = 3;
   */
  countryCode?: string;

  /**
   * @generated from field: optional string post_code = 4;
   */
  postCode?: string;

  /**
   * We can check if coupon code is available.
   *
   * @generated from field: optional string couponCode = 5;
   */
  couponCode?: string;

  /**
   * @generated from field: optional string email = 6;
   */
  email?: string;

  /**
   * @generated from field: optional string selected_delivery_method = 7;
   */
  selectedDeliveryMethod?: string;

  /**
   * @generated from field: optional string phone = 8;
   */
  phone?: string;
};

/**
 * Describes the message public_api.v1.GetPreOrderDetailsRequest.
 * Use `create(GetPreOrderDetailsRequestSchema)` to create a new message.
 */
export const GetPreOrderDetailsRequestSchema: GenMessage<GetPreOrderDetailsRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 5);

/**
 * @generated from message public_api.v1.DeliveryMethod
 */
export type DeliveryMethod = Message<"public_api.v1.DeliveryMethod"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 amount = 2;
   */
  amount: number;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: optional int32 min_days = 5;
   */
  minDays?: number;

  /**
   * @generated from field: optional int32 max_days = 6;
   */
  maxDays?: number;
};

/**
 * Describes the message public_api.v1.DeliveryMethod.
 * Use `create(DeliveryMethodSchema)` to create a new message.
 */
export const DeliveryMethodSchema: GenMessage<DeliveryMethod> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 6);

/**
 * @generated from message public_api.v1.GetPreOrderDetailsResponse
 */
export type GetPreOrderDetailsResponse = Message<"public_api.v1.GetPreOrderDetailsResponse"> & {
  /**
   * @generated from field: repeated public_api.v1.DeliveryMethod methods = 1;
   */
  methods: DeliveryMethod[];

  /**
   * @generated from field: optional string couponCode = 2;
   */
  couponCode?: string;

  /**
   * @generated from field: optional string selected_delivery_method = 3;
   */
  selectedDeliveryMethod?: string;

  /**
   * @generated from field: optional int32 total_amount = 4;
   */
  totalAmount?: number;

  /**
   * @generated from field: optional int32 coupon_value = 5;
   */
  couponValue?: number;

  /**
   * Mainly use for Google Pay
   *
   * @generated from field: string currency = 6;
   */
  currency: string;

  /**
   * @generated from field: string country = 7;
   */
  country: string;
};

/**
 * Describes the message public_api.v1.GetPreOrderDetailsResponse.
 * Use `create(GetPreOrderDetailsResponseSchema)` to create a new message.
 */
export const GetPreOrderDetailsResponseSchema: GenMessage<GetPreOrderDetailsResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 7);

/**
 * @generated from message public_api.v1.NotifyUserAboutProductAvailabilityRequest
 */
export type NotifyUserAboutProductAvailabilityRequest = Message<"public_api.v1.NotifyUserAboutProductAvailabilityRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string product_id = 2;
   */
  productId: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;
};

/**
 * Describes the message public_api.v1.NotifyUserAboutProductAvailabilityRequest.
 * Use `create(NotifyUserAboutProductAvailabilityRequestSchema)` to create a new message.
 */
export const NotifyUserAboutProductAvailabilityRequestSchema: GenMessage<NotifyUserAboutProductAvailabilityRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 8);

/**
 * @generated from message public_api.v1.ApplePayValidateMerchantRequest
 */
export type ApplePayValidateMerchantRequest = Message<"public_api.v1.ApplePayValidateMerchantRequest"> & {
  /**
   * @generated from field: string validation_url = 1;
   */
  validationUrl: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;
};

/**
 * Describes the message public_api.v1.ApplePayValidateMerchantRequest.
 * Use `create(ApplePayValidateMerchantRequestSchema)` to create a new message.
 */
export const ApplePayValidateMerchantRequestSchema: GenMessage<ApplePayValidateMerchantRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 9);

/**
 * @generated from message public_api.v1.ApplePayValidateMerchantResponse
 */
export type ApplePayValidateMerchantResponse = Message<"public_api.v1.ApplePayValidateMerchantResponse"> & {
  /**
   * @generated from field: string merchant_session = 1;
   */
  merchantSession: string;
};

/**
 * Describes the message public_api.v1.ApplePayValidateMerchantResponse.
 * Use `create(ApplePayValidateMerchantResponseSchema)` to create a new message.
 */
export const ApplePayValidateMerchantResponseSchema: GenMessage<ApplePayValidateMerchantResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 10);

/**
 * @generated from message public_api.v1.GetAvailableCountForProductRequest
 */
export type GetAvailableCountForProductRequest = Message<"public_api.v1.GetAvailableCountForProductRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: repeated string all_variants = 2;
   */
  allVariants: string[];
};

/**
 * Describes the message public_api.v1.GetAvailableCountForProductRequest.
 * Use `create(GetAvailableCountForProductRequestSchema)` to create a new message.
 */
export const GetAvailableCountForProductRequestSchema: GenMessage<GetAvailableCountForProductRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 11);

/**
 * @generated from message public_api.v1.GetAvailableCountForProductResponse
 */
export type GetAvailableCountForProductResponse = Message<"public_api.v1.GetAvailableCountForProductResponse"> & {
  /**
   * @generated from field: map<string, public_api.v1.GetAvailableCountForProductResponse.AvailableCountForProduct> available_counts = 1;
   */
  availableCounts: { [key: string]: GetAvailableCountForProductResponse_AvailableCountForProduct };

  /**
   * @generated from field: optional public_api.v1.GetAvailableCountForProductResponse.Error error = 2;
   */
  error?: GetAvailableCountForProductResponse_Error;
};

/**
 * Describes the message public_api.v1.GetAvailableCountForProductResponse.
 * Use `create(GetAvailableCountForProductResponseSchema)` to create a new message.
 */
export const GetAvailableCountForProductResponseSchema: GenMessage<GetAvailableCountForProductResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 12);

/**
 * @generated from message public_api.v1.GetAvailableCountForProductResponse.AvailableCountForProduct
 */
export type GetAvailableCountForProductResponse_AvailableCountForProduct = Message<"public_api.v1.GetAvailableCountForProductResponse.AvailableCountForProduct"> & {
  /**
   * @generated from field: int32 available_quantity_to_order = 1;
   */
  availableQuantityToOrder: number;

  /**
   * @generated from field: bool can_back = 2;
   */
  canBack: boolean;
};

/**
 * Describes the message public_api.v1.GetAvailableCountForProductResponse.AvailableCountForProduct.
 * Use `create(GetAvailableCountForProductResponse_AvailableCountForProductSchema)` to create a new message.
 */
export const GetAvailableCountForProductResponse_AvailableCountForProductSchema: GenMessage<GetAvailableCountForProductResponse_AvailableCountForProduct> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 12, 0);

/**
 * @generated from enum public_api.v1.GetAvailableCountForProductResponse.Error
 */
export enum GetAvailableCountForProductResponse_Error {
  /**
   * @generated from enum value: ERROR_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: ERROR_PROJECT_NOT_FOUND = 1;
   */
  PROJECT_NOT_FOUND = 1,

  /**
   * @generated from enum value: ERROR_PRODUCT_NOT_AVAILABLE = 2;
   */
  PRODUCT_NOT_AVAILABLE = 2,

  /**
   * @generated from enum value: ERROR_PRODUCT_NOT_AVAILABLE_BUT_CAN_BACK = 3;
   */
  PRODUCT_NOT_AVAILABLE_BUT_CAN_BACK = 3,
}

/**
 * Describes the enum public_api.v1.GetAvailableCountForProductResponse.Error.
 */
export const GetAvailableCountForProductResponse_ErrorSchema: GenEnum<GetAvailableCountForProductResponse_Error> = /*@__PURE__*/
  enumDesc(file_public_v1_public_api, 12, 0);

/**
 * @generated from message public_api.v1.UserPanelDeleteAccountRequest
 */
export type UserPanelDeleteAccountRequest = Message<"public_api.v1.UserPanelDeleteAccountRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message public_api.v1.UserPanelDeleteAccountRequest.
 * Use `create(UserPanelDeleteAccountRequestSchema)` to create a new message.
 */
export const UserPanelDeleteAccountRequestSchema: GenMessage<UserPanelDeleteAccountRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 13);

/**
 * @generated from message public_api.v1.DidBuyProductRequest
 */
export type DidBuyProductRequest = Message<"public_api.v1.DidBuyProductRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string product_id = 2;
   */
  productId: string;
};

/**
 * Describes the message public_api.v1.DidBuyProductRequest.
 * Use `create(DidBuyProductRequestSchema)` to create a new message.
 */
export const DidBuyProductRequestSchema: GenMessage<DidBuyProductRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 14);

/**
 * @generated from message public_api.v1.UpdateNotificationSettingsRequest
 */
export type UpdateNotificationSettingsRequest = Message<"public_api.v1.UpdateNotificationSettingsRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * @generated from field: repeated public_api.v1.UpdateNotificationSettingsRequest.Group modifications = 3;
   */
  modifications: UpdateNotificationSettingsRequest_Group[];

  /**
   * @generated from field: repeated public_api.v1.NotificationMethod enabled_methods = 4;
   */
  enabledMethods: NotificationMethod[];
};

/**
 * Describes the message public_api.v1.UpdateNotificationSettingsRequest.
 * Use `create(UpdateNotificationSettingsRequestSchema)` to create a new message.
 */
export const UpdateNotificationSettingsRequestSchema: GenMessage<UpdateNotificationSettingsRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 15);

/**
 * @generated from message public_api.v1.UpdateNotificationSettingsRequest.Group
 */
export type UpdateNotificationSettingsRequest_Group = Message<"public_api.v1.UpdateNotificationSettingsRequest.Group"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message public_api.v1.UpdateNotificationSettingsRequest.Group.
 * Use `create(UpdateNotificationSettingsRequest_GroupSchema)` to create a new message.
 */
export const UpdateNotificationSettingsRequest_GroupSchema: GenMessage<UpdateNotificationSettingsRequest_Group> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 15, 0);

/**
 * @generated from message public_api.v1.UpdateGlobalNotificationSettingsRequest
 */
export type UpdateGlobalNotificationSettingsRequest = Message<"public_api.v1.UpdateGlobalNotificationSettingsRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: bool is_muted = 2;
   */
  isMuted: boolean;
};

/**
 * Describes the message public_api.v1.UpdateGlobalNotificationSettingsRequest.
 * Use `create(UpdateGlobalNotificationSettingsRequestSchema)` to create a new message.
 */
export const UpdateGlobalNotificationSettingsRequestSchema: GenMessage<UpdateGlobalNotificationSettingsRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 16);

/**
 * @generated from message public_api.v1.GetNotificationSettingsDetailsRequest
 */
export type GetNotificationSettingsDetailsRequest = Message<"public_api.v1.GetNotificationSettingsDetailsRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;
};

/**
 * Describes the message public_api.v1.GetNotificationSettingsDetailsRequest.
 * Use `create(GetNotificationSettingsDetailsRequestSchema)` to create a new message.
 */
export const GetNotificationSettingsDetailsRequestSchema: GenMessage<GetNotificationSettingsDetailsRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 17);

/**
 * @generated from message public_api.v1.NotificationGroup
 */
export type NotificationGroup = Message<"public_api.v1.NotificationGroup"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;

  /**
   * @generated from field: common.v1.NotificationGroupHowOften how_often = 5;
   */
  howOften: NotificationGroupHowOften;
};

/**
 * Describes the message public_api.v1.NotificationGroup.
 * Use `create(NotificationGroupSchema)` to create a new message.
 */
export const NotificationGroupSchema: GenMessage<NotificationGroup> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 18);

/**
 * @generated from message public_api.v1.GetNotificationSettingsDetailsResponse
 */
export type GetNotificationSettingsDetailsResponse = Message<"public_api.v1.GetNotificationSettingsDetailsResponse"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional public_api.v1.ProjectTheme theme = 3;
   */
  theme?: ProjectTheme;

  /**
   * @generated from field: repeated public_api.v1.NotificationMethod available_methods = 4;
   */
  availableMethods: NotificationMethod[];

  /**
   * @generated from field: repeated public_api.v1.NotificationMethod enabled_methods = 5;
   */
  enabledMethods: NotificationMethod[];

  /**
   * @generated from field: repeated public_api.v1.NotificationGroup groups = 6;
   */
  groups: NotificationGroup[];
};

/**
 * Describes the message public_api.v1.GetNotificationSettingsDetailsResponse.
 * Use `create(GetNotificationSettingsDetailsResponseSchema)` to create a new message.
 */
export const GetNotificationSettingsDetailsResponseSchema: GenMessage<GetNotificationSettingsDetailsResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 19);

/**
 * @generated from message public_api.v1.GetNotificationSettingsRequest
 */
export type GetNotificationSettingsRequest = Message<"public_api.v1.GetNotificationSettingsRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: bool all = 2;
   */
  all: boolean;
};

/**
 * Describes the message public_api.v1.GetNotificationSettingsRequest.
 * Use `create(GetNotificationSettingsRequestSchema)` to create a new message.
 */
export const GetNotificationSettingsRequestSchema: GenMessage<GetNotificationSettingsRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 20);

/**
 * @generated from message public_api.v1.GetNotificationSettingsResponse
 */
export type GetNotificationSettingsResponse = Message<"public_api.v1.GetNotificationSettingsResponse"> & {
  /**
   * @generated from field: repeated public_api.v1.GetNotificationSettingsResponse.Project projects = 1;
   */
  projects: GetNotificationSettingsResponse_Project[];

  /**
   * @generated from field: bool is_muted = 2;
   */
  isMuted: boolean;
};

/**
 * Describes the message public_api.v1.GetNotificationSettingsResponse.
 * Use `create(GetNotificationSettingsResponseSchema)` to create a new message.
 */
export const GetNotificationSettingsResponseSchema: GenMessage<GetNotificationSettingsResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 21);

/**
 * @generated from message public_api.v1.GetNotificationSettingsResponse.Project
 */
export type GetNotificationSettingsResponse_Project = Message<"public_api.v1.GetNotificationSettingsResponse.Project"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: public_api.v1.GetNotificationSettingsResponse.Status status = 3;
   */
  status: GetNotificationSettingsResponse_Status;

  /**
   * @generated from field: optional public_api.v1.ProjectTheme theme = 4;
   */
  theme?: ProjectTheme;
};

/**
 * Describes the message public_api.v1.GetNotificationSettingsResponse.Project.
 * Use `create(GetNotificationSettingsResponse_ProjectSchema)` to create a new message.
 */
export const GetNotificationSettingsResponse_ProjectSchema: GenMessage<GetNotificationSettingsResponse_Project> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 21, 0);

/**
 * @generated from enum public_api.v1.GetNotificationSettingsResponse.Status
 */
export enum GetNotificationSettingsResponse_Status {
  /**
   * @generated from enum value: STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATUS_ENABLED = 1;
   */
  ENABLED = 1,

  /**
   * @generated from enum value: STATUS_DISABLED = 2;
   */
  DISABLED = 2,
}

/**
 * Describes the enum public_api.v1.GetNotificationSettingsResponse.Status.
 */
export const GetNotificationSettingsResponse_StatusSchema: GenEnum<GetNotificationSettingsResponse_Status> = /*@__PURE__*/
  enumDesc(file_public_v1_public_api, 21, 0);

/**
 * @generated from message public_api.v1.UserPanelPushGetAvailableCompaniesRequest
 */
export type UserPanelPushGetAvailableCompaniesRequest = Message<"public_api.v1.UserPanelPushGetAvailableCompaniesRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message public_api.v1.UserPanelPushGetAvailableCompaniesRequest.
 * Use `create(UserPanelPushGetAvailableCompaniesRequestSchema)` to create a new message.
 */
export const UserPanelPushGetAvailableCompaniesRequestSchema: GenMessage<UserPanelPushGetAvailableCompaniesRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 22);

/**
 * @generated from message public_api.v1.UserPanelPushGetAvailableCompaniesResponse
 */
export type UserPanelPushGetAvailableCompaniesResponse = Message<"public_api.v1.UserPanelPushGetAvailableCompaniesResponse"> & {
  /**
   * @generated from field: repeated public_api.v1.UserPanelPushGetAvailableCompaniesResponse.Company companies = 1;
   */
  companies: UserPanelPushGetAvailableCompaniesResponse_Company[];
};

/**
 * Describes the message public_api.v1.UserPanelPushGetAvailableCompaniesResponse.
 * Use `create(UserPanelPushGetAvailableCompaniesResponseSchema)` to create a new message.
 */
export const UserPanelPushGetAvailableCompaniesResponseSchema: GenMessage<UserPanelPushGetAvailableCompaniesResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 23);

/**
 * @generated from message public_api.v1.UserPanelPushGetAvailableCompaniesResponse.Group
 */
export type UserPanelPushGetAvailableCompaniesResponse_Group = Message<"public_api.v1.UserPanelPushGetAvailableCompaniesResponse.Group"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional string how_often = 4;
   */
  howOften?: string;
};

/**
 * Describes the message public_api.v1.UserPanelPushGetAvailableCompaniesResponse.Group.
 * Use `create(UserPanelPushGetAvailableCompaniesResponse_GroupSchema)` to create a new message.
 */
export const UserPanelPushGetAvailableCompaniesResponse_GroupSchema: GenMessage<UserPanelPushGetAvailableCompaniesResponse_Group> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 23, 0);

/**
 * @generated from message public_api.v1.UserPanelPushGetAvailableCompaniesResponse.Company
 */
export type UserPanelPushGetAvailableCompaniesResponse_Company = Message<"public_api.v1.UserPanelPushGetAvailableCompaniesResponse.Company"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated public_api.v1.UserPanelPushGetAvailableCompaniesResponse.Group groups = 3;
   */
  groups: UserPanelPushGetAvailableCompaniesResponse_Group[];
};

/**
 * Describes the message public_api.v1.UserPanelPushGetAvailableCompaniesResponse.Company.
 * Use `create(UserPanelPushGetAvailableCompaniesResponse_CompanySchema)` to create a new message.
 */
export const UserPanelPushGetAvailableCompaniesResponse_CompanySchema: GenMessage<UserPanelPushGetAvailableCompaniesResponse_Company> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 23, 1);

/**
 * @generated from message public_api.v1.ShouldShopProductsResponse
 */
export type ShouldShopProductsResponse = Message<"public_api.v1.ShouldShopProductsResponse"> & {
  /**
   * @generated from field: bool is_visible = 1;
   */
  isVisible: boolean;
};

/**
 * Describes the message public_api.v1.ShouldShopProductsResponse.
 * Use `create(ShouldShopProductsResponseSchema)` to create a new message.
 */
export const ShouldShopProductsResponseSchema: GenMessage<ShouldShopProductsResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 24);

/**
 * @generated from message public_api.v1.GetShopProductsRequest
 */
export type GetShopProductsRequest = Message<"public_api.v1.GetShopProductsRequest"> & {
  /**
   * @generated from field: optional string access_token = 1;
   */
  accessToken?: string;
};

/**
 * Describes the message public_api.v1.GetShopProductsRequest.
 * Use `create(GetShopProductsRequestSchema)` to create a new message.
 */
export const GetShopProductsRequestSchema: GenMessage<GetShopProductsRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 25);

/**
 * @generated from message public_api.v1.GetShopProductsResponse
 */
export type GetShopProductsResponse = Message<"public_api.v1.GetShopProductsResponse"> & {
  /**
   * @generated from field: repeated public_api.v1.GetShopProductsResponse.Product products = 5;
   */
  products: GetShopProductsResponse_Product[];
};

/**
 * Describes the message public_api.v1.GetShopProductsResponse.
 * Use `create(GetShopProductsResponseSchema)` to create a new message.
 */
export const GetShopProductsResponseSchema: GenMessage<GetShopProductsResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 26);

/**
 * @generated from message public_api.v1.GetShopProductsResponse.Product
 */
export type GetShopProductsResponse_Product = Message<"public_api.v1.GetShopProductsResponse.Product"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string image_url = 3;
   */
  imageUrl: string;

  /**
   * @generated from field: string price = 4;
   */
  price: string;

  /**
   * @generated from field: optional bool is_already_bought = 5;
   */
  isAlreadyBought?: boolean;
};

/**
 * Describes the message public_api.v1.GetShopProductsResponse.Product.
 * Use `create(GetShopProductsResponse_ProductSchema)` to create a new message.
 */
export const GetShopProductsResponse_ProductSchema: GenMessage<GetShopProductsResponse_Product> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 26, 0);

/**
 * @generated from message public_api.v1.UserPanelGetFileDetailsResponse
 */
export type UserPanelGetFileDetailsResponse = Message<"public_api.v1.UserPanelGetFileDetailsResponse"> & {
  /**
   * @generated from oneof public_api.v1.UserPanelGetFileDetailsResponse.result
   */
  result: {
    /**
     * @generated from field: public_api.v1.UserPanelGetFileDetailsResponse.Result success = 1;
     */
    value: UserPanelGetFileDetailsResponse_Result;
    case: "success";
  } | {
    /**
     * @generated from field: public_api.v1.FailureMessage failure = 2;
     */
    value: FailureMessage;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message public_api.v1.UserPanelGetFileDetailsResponse.
 * Use `create(UserPanelGetFileDetailsResponseSchema)` to create a new message.
 */
export const UserPanelGetFileDetailsResponseSchema: GenMessage<UserPanelGetFileDetailsResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 27);

/**
 * @generated from message public_api.v1.UserPanelGetFileDetailsResponse.Result
 */
export type UserPanelGetFileDetailsResponse_Result = Message<"public_api.v1.UserPanelGetFileDetailsResponse.Result"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: repeated string files = 2;
   */
  files: string[];
};

/**
 * Describes the message public_api.v1.UserPanelGetFileDetailsResponse.Result.
 * Use `create(UserPanelGetFileDetailsResponse_ResultSchema)` to create a new message.
 */
export const UserPanelGetFileDetailsResponse_ResultSchema: GenMessage<UserPanelGetFileDetailsResponse_Result> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 27, 0);

/**
 * @generated from message public_api.v1.UserPanelGetFileDetailsRequest
 */
export type UserPanelGetFileDetailsRequest = Message<"public_api.v1.UserPanelGetFileDetailsRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string access_id = 2;
   */
  accessId: string;
};

/**
 * Describes the message public_api.v1.UserPanelGetFileDetailsRequest.
 * Use `create(UserPanelGetFileDetailsRequestSchema)` to create a new message.
 */
export const UserPanelGetFileDetailsRequestSchema: GenMessage<UserPanelGetFileDetailsRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 28);

/**
 * @generated from message public_api.v1.UserPanelGetTicketDetailsResponse
 */
export type UserPanelGetTicketDetailsResponse = Message<"public_api.v1.UserPanelGetTicketDetailsResponse"> & {
  /**
   * @generated from oneof public_api.v1.UserPanelGetTicketDetailsResponse.result
   */
  result: {
    /**
     * @generated from field: public_api.v1.UserPanelGetTicketDetailsResponse.Result success = 1;
     */
    value: UserPanelGetTicketDetailsResponse_Result;
    case: "success";
  } | {
    /**
     * @generated from field: public_api.v1.FailureMessage failure = 2;
     */
    value: FailureMessage;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message public_api.v1.UserPanelGetTicketDetailsResponse.
 * Use `create(UserPanelGetTicketDetailsResponseSchema)` to create a new message.
 */
export const UserPanelGetTicketDetailsResponseSchema: GenMessage<UserPanelGetTicketDetailsResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 29);

/**
 * @generated from message public_api.v1.UserPanelGetTicketDetailsResponse.Result
 */
export type UserPanelGetTicketDetailsResponse_Result = Message<"public_api.v1.UserPanelGetTicketDetailsResponse.Result"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string ticket_url = 2;
   */
  ticketUrl: string;

  /**
   * @generated from field: string product_name = 3;
   */
  productName: string;

  /**
   * @generated from field: string product_image_url = 4;
   */
  productImageUrl: string;

  /**
   * @generated from field: optional string google_wallet_url = 5;
   */
  googleWalletUrl?: string;

  /**
   * @generated from field: optional string apple_wallet_url = 6;
   */
  appleWalletUrl?: string;
};

/**
 * Describes the message public_api.v1.UserPanelGetTicketDetailsResponse.Result.
 * Use `create(UserPanelGetTicketDetailsResponse_ResultSchema)` to create a new message.
 */
export const UserPanelGetTicketDetailsResponse_ResultSchema: GenMessage<UserPanelGetTicketDetailsResponse_Result> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 29, 0);

/**
 * @generated from message public_api.v1.UserPanelGetTicketDetailsRequest
 */
export type UserPanelGetTicketDetailsRequest = Message<"public_api.v1.UserPanelGetTicketDetailsRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string access_id = 2;
   */
  accessId: string;
};

/**
 * Describes the message public_api.v1.UserPanelGetTicketDetailsRequest.
 * Use `create(UserPanelGetTicketDetailsRequestSchema)` to create a new message.
 */
export const UserPanelGetTicketDetailsRequestSchema: GenMessage<UserPanelGetTicketDetailsRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 30);

/**
 * @generated from message public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsResponse
 */
export type UserPanelGetAudiobookDetailsDownloadURLsResponse = Message<"public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsResponse"> & {
  /**
   * @generated from oneof public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsResponse.result
   */
  result: {
    /**
     * @generated from field: public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsResponse.Result success = 1;
     */
    value: UserPanelGetAudiobookDetailsDownloadURLsResponse_Result;
    case: "success";
  } | {
    /**
     * @generated from field: public_api.v1.FailureMessage failure = 2;
     */
    value: FailureMessage;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsResponse.
 * Use `create(UserPanelGetAudiobookDetailsDownloadURLsResponseSchema)` to create a new message.
 */
export const UserPanelGetAudiobookDetailsDownloadURLsResponseSchema: GenMessage<UserPanelGetAudiobookDetailsDownloadURLsResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 31);

/**
 * @generated from message public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsResponse.AudiobookDownloadDetails
 */
export type UserPanelGetAudiobookDetailsDownloadURLsResponse_AudiobookDownloadDetails = Message<"public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsResponse.AudiobookDownloadDetails"> & {
  /**
   * @generated from field: string chapter_id = 1;
   */
  chapterId: string;

  /**
   * @generated from field: string public_url = 2;
   */
  publicUrl: string;

  /**
   * @generated from field: optional string downloadable_url = 3;
   */
  downloadableUrl?: string;
};

/**
 * Describes the message public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsResponse.AudiobookDownloadDetails.
 * Use `create(UserPanelGetAudiobookDetailsDownloadURLsResponse_AudiobookDownloadDetailsSchema)` to create a new message.
 */
export const UserPanelGetAudiobookDetailsDownloadURLsResponse_AudiobookDownloadDetailsSchema: GenMessage<UserPanelGetAudiobookDetailsDownloadURLsResponse_AudiobookDownloadDetails> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 31, 0);

/**
 * @generated from message public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsResponse.Result
 */
export type UserPanelGetAudiobookDetailsDownloadURLsResponse_Result = Message<"public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsResponse.Result"> & {
  /**
   * @generated from field: repeated public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsResponse.AudiobookDownloadDetails audiobook_download_details = 1;
   */
  audiobookDownloadDetails: UserPanelGetAudiobookDetailsDownloadURLsResponse_AudiobookDownloadDetails[];

  /**
   * @generated from field: optional bool is_available_to_download_in_mobile_app = 2;
   */
  isAvailableToDownloadInMobileApp?: boolean;
};

/**
 * Describes the message public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsResponse.Result.
 * Use `create(UserPanelGetAudiobookDetailsDownloadURLsResponse_ResultSchema)` to create a new message.
 */
export const UserPanelGetAudiobookDetailsDownloadURLsResponse_ResultSchema: GenMessage<UserPanelGetAudiobookDetailsDownloadURLsResponse_Result> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 31, 1);

/**
 * @generated from message public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsRequest
 */
export type UserPanelGetAudiobookDetailsDownloadURLsRequest = Message<"public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string access_id = 2;
   */
  accessId: string;

  /**
   * @generated from field: optional bool is_browser = 3;
   */
  isBrowser?: boolean;
};

/**
 * Describes the message public_api.v1.UserPanelGetAudiobookDetailsDownloadURLsRequest.
 * Use `create(UserPanelGetAudiobookDetailsDownloadURLsRequestSchema)` to create a new message.
 */
export const UserPanelGetAudiobookDetailsDownloadURLsRequestSchema: GenMessage<UserPanelGetAudiobookDetailsDownloadURLsRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 32);

/**
 * @generated from message public_api.v1.UserPanelGetAudiobookDetailsResponse
 */
export type UserPanelGetAudiobookDetailsResponse = Message<"public_api.v1.UserPanelGetAudiobookDetailsResponse"> & {
  /**
   * @generated from oneof public_api.v1.UserPanelGetAudiobookDetailsResponse.result
   */
  result: {
    /**
     * @generated from field: dashboard.audiobooks.v1.Audiobook audiobook = 1;
     */
    value: Audiobook$1;
    case: "audiobook";
  } | {
    /**
     * @generated from field: public_api.v1.FailureMessage failure = 2;
     */
    value: FailureMessage;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message public_api.v1.UserPanelGetAudiobookDetailsResponse.
 * Use `create(UserPanelGetAudiobookDetailsResponseSchema)` to create a new message.
 */
export const UserPanelGetAudiobookDetailsResponseSchema: GenMessage<UserPanelGetAudiobookDetailsResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 33);

/**
 * @generated from message public_api.v1.UserPanelGetAudiobookDetailsRequest
 */
export type UserPanelGetAudiobookDetailsRequest = Message<"public_api.v1.UserPanelGetAudiobookDetailsRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string access_id = 2;
   */
  accessId: string;
};

/**
 * Describes the message public_api.v1.UserPanelGetAudiobookDetailsRequest.
 * Use `create(UserPanelGetAudiobookDetailsRequestSchema)` to create a new message.
 */
export const UserPanelGetAudiobookDetailsRequestSchema: GenMessage<UserPanelGetAudiobookDetailsRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 34);

/**
 * @generated from message public_api.v1.UserPanelGetProductsRequest
 */
export type UserPanelGetProductsRequest = Message<"public_api.v1.UserPanelGetProductsRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message public_api.v1.UserPanelGetProductsRequest.
 * Use `create(UserPanelGetProductsRequestSchema)` to create a new message.
 */
export const UserPanelGetProductsRequestSchema: GenMessage<UserPanelGetProductsRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 35);

/**
 * @generated from message public_api.v1.UserPanelGetProductsResponse
 */
export type UserPanelGetProductsResponse = Message<"public_api.v1.UserPanelGetProductsResponse"> & {
  /**
   * @generated from oneof public_api.v1.UserPanelGetProductsResponse.result
   */
  result: {
    /**
     * @generated from field: public_api.v1.UserPanelGetProductsResponse.Result success = 1;
     */
    value: UserPanelGetProductsResponse_Result;
    case: "success";
  } | {
    /**
     * @generated from field: public_api.v1.FailureMessage failure = 2;
     */
    value: FailureMessage;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message public_api.v1.UserPanelGetProductsResponse.
 * Use `create(UserPanelGetProductsResponseSchema)` to create a new message.
 */
export const UserPanelGetProductsResponseSchema: GenMessage<UserPanelGetProductsResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 36);

/**
 * @generated from message public_api.v1.UserPanelGetProductsResponse.Result
 */
export type UserPanelGetProductsResponse_Result = Message<"public_api.v1.UserPanelGetProductsResponse.Result"> & {
  /**
   * @generated from field: repeated public_api.v1.UserProduct products = 1;
   */
  products: UserProduct[];
};

/**
 * Describes the message public_api.v1.UserPanelGetProductsResponse.Result.
 * Use `create(UserPanelGetProductsResponse_ResultSchema)` to create a new message.
 */
export const UserPanelGetProductsResponse_ResultSchema: GenMessage<UserPanelGetProductsResponse_Result> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 36, 0);

/**
 * @generated from message public_api.v1.UserPanelLogoutRequest
 */
export type UserPanelLogoutRequest = Message<"public_api.v1.UserPanelLogoutRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message public_api.v1.UserPanelLogoutRequest.
 * Use `create(UserPanelLogoutRequestSchema)` to create a new message.
 */
export const UserPanelLogoutRequestSchema: GenMessage<UserPanelLogoutRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 37);

/**
 * @generated from message public_api.v1.UserPanelLoginWithCodeResponse
 */
export type UserPanelLoginWithCodeResponse = Message<"public_api.v1.UserPanelLoginWithCodeResponse"> & {
  /**
   * @generated from oneof public_api.v1.UserPanelLoginWithCodeResponse.result
   */
  result: {
    /**
     * @generated from field: string access_token = 1;
     */
    value: string;
    case: "accessToken";
  } | {
    /**
     * @generated from field: public_api.v1.FailureMessage failure = 2;
     */
    value: FailureMessage;
    case: "failure";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional string email = 3;
   */
  email?: string;

  /**
   * @generated from field: optional string user_id = 4;
   */
  userId?: string;
};

/**
 * Describes the message public_api.v1.UserPanelLoginWithCodeResponse.
 * Use `create(UserPanelLoginWithCodeResponseSchema)` to create a new message.
 */
export const UserPanelLoginWithCodeResponseSchema: GenMessage<UserPanelLoginWithCodeResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 38);

/**
 * @generated from message public_api.v1.UserPanelLoginWithCodeRequest
 */
export type UserPanelLoginWithCodeRequest = Message<"public_api.v1.UserPanelLoginWithCodeRequest"> & {
  /**
   * @generated from field: int32 code = 1;
   */
  code: number;
};

/**
 * Describes the message public_api.v1.UserPanelLoginWithCodeRequest.
 * Use `create(UserPanelLoginWithCodeRequestSchema)` to create a new message.
 */
export const UserPanelLoginWithCodeRequestSchema: GenMessage<UserPanelLoginWithCodeRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 39);

/**
 * @generated from message public_api.v1.UserPanelLoginResponse
 */
export type UserPanelLoginResponse = Message<"public_api.v1.UserPanelLoginResponse"> & {
  /**
   * @generated from oneof public_api.v1.UserPanelLoginResponse.result
   */
  result: {
    /**
     * @generated from field: public_api.v1.UserPanelLoginResponse.Result success = 1;
     */
    value: UserPanelLoginResponse_Result;
    case: "success";
  } | {
    /**
     * @generated from field: public_api.v1.FailureMessage failure = 2;
     */
    value: FailureMessage;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message public_api.v1.UserPanelLoginResponse.
 * Use `create(UserPanelLoginResponseSchema)` to create a new message.
 */
export const UserPanelLoginResponseSchema: GenMessage<UserPanelLoginResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 40);

/**
 * @generated from message public_api.v1.UserPanelLoginResponse.Result
 */
export type UserPanelLoginResponse_Result = Message<"public_api.v1.UserPanelLoginResponse.Result"> & {
  /**
   * @generated from field: int32 retry_in = 1;
   */
  retryIn: number;
};

/**
 * Describes the message public_api.v1.UserPanelLoginResponse.Result.
 * Use `create(UserPanelLoginResponse_ResultSchema)` to create a new message.
 */
export const UserPanelLoginResponse_ResultSchema: GenMessage<UserPanelLoginResponse_Result> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 40, 0);

/**
 * @generated from message public_api.v1.UserPanelLoginRequest
 */
export type UserPanelLoginRequest = Message<"public_api.v1.UserPanelLoginRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: optional bool regulations_accept = 2;
   */
  regulationsAccept?: boolean;
};

/**
 * Describes the message public_api.v1.UserPanelLoginRequest.
 * Use `create(UserPanelLoginRequestSchema)` to create a new message.
 */
export const UserPanelLoginRequestSchema: GenMessage<UserPanelLoginRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 41);

/**
 * @generated from message public_api.v1.GetOrderRetryUrlRequest
 */
export type GetOrderRetryUrlRequest = Message<"public_api.v1.GetOrderRetryUrlRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;
};

/**
 * Describes the message public_api.v1.GetOrderRetryUrlRequest.
 * Use `create(GetOrderRetryUrlRequestSchema)` to create a new message.
 */
export const GetOrderRetryUrlRequestSchema: GenMessage<GetOrderRetryUrlRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 42);

/**
 * @generated from message public_api.v1.GetOrderRetryUrlResponse
 */
export type GetOrderRetryUrlResponse = Message<"public_api.v1.GetOrderRetryUrlResponse"> & {
  /**
   * @generated from oneof public_api.v1.GetOrderRetryUrlResponse.result
   */
  result: {
    /**
     * @generated from field: public_api.v1.GetOrderRetryUrlResponse.Success url = 1;
     */
    value: GetOrderRetryUrlResponse_Success;
    case: "url";
  } | {
    /**
     * @generated from field: string failure = 2;
     */
    value: string;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message public_api.v1.GetOrderRetryUrlResponse.
 * Use `create(GetOrderRetryUrlResponseSchema)` to create a new message.
 */
export const GetOrderRetryUrlResponseSchema: GenMessage<GetOrderRetryUrlResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 43);

/**
 * @generated from message public_api.v1.GetOrderRetryUrlResponse.Success
 */
export type GetOrderRetryUrlResponse_Success = Message<"public_api.v1.GetOrderRetryUrlResponse.Success"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message public_api.v1.GetOrderRetryUrlResponse.Success.
 * Use `create(GetOrderRetryUrlResponse_SuccessSchema)` to create a new message.
 */
export const GetOrderRetryUrlResponse_SuccessSchema: GenMessage<GetOrderRetryUrlResponse_Success> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 43, 0);

/**
 * @generated from message public_api.v1.GetOrderRequest
 */
export type GetOrderRequest = Message<"public_api.v1.GetOrderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;
};

/**
 * Describes the message public_api.v1.GetOrderRequest.
 * Use `create(GetOrderRequestSchema)` to create a new message.
 */
export const GetOrderRequestSchema: GenMessage<GetOrderRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 44);

/**
 * @generated from message public_api.v1.GetOrderResponse
 */
export type GetOrderResponse = Message<"public_api.v1.GetOrderResponse"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * @generated from field: repeated public_api.v1.Item items = 2;
   */
  items: Item[];

  /**
   * @generated from field: public_api.v1.OrderDetails details = 3;
   */
  details?: OrderDetails;
};

/**
 * Describes the message public_api.v1.GetOrderResponse.
 * Use `create(GetOrderResponseSchema)` to create a new message.
 */
export const GetOrderResponseSchema: GenMessage<GetOrderResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 45);

/**
 * @generated from message public_api.v1.OrderDetails
 */
export type OrderDetails = Message<"public_api.v1.OrderDetails"> & {
  /**
   * @generated from field: repeated public_api.v1.OrderDetails.SingleItem items = 1;
   */
  items: OrderDetails_SingleItem[];

  /**
   * @generated from field: common.v1.Gateway gateway = 2;
   */
  gateway: Gateway;
};

/**
 * Describes the message public_api.v1.OrderDetails.
 * Use `create(OrderDetailsSchema)` to create a new message.
 */
export const OrderDetailsSchema: GenMessage<OrderDetails> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 46);

/**
 * @generated from message public_api.v1.OrderDetails.SingleItem
 */
export type OrderDetails_SingleItem = Message<"public_api.v1.OrderDetails.SingleItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string image_url = 2;
   */
  imageUrl?: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: int32 quantity = 4;
   */
  quantity: number;

  /**
   * @generated from field: int64 price_amount = 5;
   */
  priceAmount: bigint;

  /**
   * @generated from field: string price_currency = 6;
   */
  priceCurrency: string;
};

/**
 * Describes the message public_api.v1.OrderDetails.SingleItem.
 * Use `create(OrderDetails_SingleItemSchema)` to create a new message.
 */
export const OrderDetails_SingleItemSchema: GenMessage<OrderDetails_SingleItem> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 46, 0);

/**
 * @generated from message public_api.v1.Item
 */
export type Item = Message<"public_api.v1.Item"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string image_url = 3;
   */
  imageUrl: string;

  /**
   * @generated from oneof public_api.v1.Item.item
   */
  item: {
    /**
     * @generated from field: public_api.v1.FileDownloadable file_downloadable = 4;
     */
    value: FileDownloadable;
    case: "fileDownloadable";
  } | {
    /**
     * @generated from field: public_api.v1.Audiobook audiobook = 5;
     */
    value: Audiobook;
    case: "audiobook";
  } | {
    /**
     * @generated from field: public_api.v1.Ticket ticket = 6;
     */
    value: Ticket;
    case: "ticket";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message public_api.v1.Item.
 * Use `create(ItemSchema)` to create a new message.
 */
export const ItemSchema: GenMessage<Item> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 47);

/**
 * @generated from message public_api.v1.FileDownloadable
 */
export type FileDownloadable = Message<"public_api.v1.FileDownloadable"> & {
  /**
   * @generated from field: string file_url = 1;
   */
  fileUrl: string;
};

/**
 * Describes the message public_api.v1.FileDownloadable.
 * Use `create(FileDownloadableSchema)` to create a new message.
 */
export const FileDownloadableSchema: GenMessage<FileDownloadable> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 48);

/**
 * @generated from message public_api.v1.Audiobook
 */
export type Audiobook = Message<"public_api.v1.Audiobook"> & {
  /**
   * @generated from field: string app_download_url = 1;
   */
  appDownloadUrl: string;
};

/**
 * Describes the message public_api.v1.Audiobook.
 * Use `create(AudiobookSchema)` to create a new message.
 */
export const AudiobookSchema: GenMessage<Audiobook> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 49);

/**
 * @generated from message public_api.v1.Ticket
 */
export type Ticket = Message<"public_api.v1.Ticket"> & {
  /**
   * @generated from field: string ticket_id = 1;
   */
  ticketId: string;

  /**
   * @generated from field: optional string apple_pass_url = 2;
   */
  applePassUrl?: string;

  /**
   * @generated from field: optional string google_ticket_url = 3;
   */
  googleTicketUrl?: string;
};

/**
 * Describes the message public_api.v1.Ticket.
 * Use `create(TicketSchema)` to create a new message.
 */
export const TicketSchema: GenMessage<Ticket> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 50);

/**
 * @generated from message public_api.v1.UserProduct
 */
export type UserProduct = Message<"public_api.v1.UserProduct"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string project_name = 2;
   */
  projectName: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId: string;

  /**
   * @generated from field: string product_name = 4;
   */
  productName: string;

  /**
   * @generated from field: string product_description = 5;
   */
  productDescription: string;

  /**
   * @generated from field: string product_image_url = 6;
   */
  productImageUrl: string;

  /**
   * @generated from field: public_api.v1.UserProductType product_type = 7;
   */
  productType: UserProductType;

  /**
   * @generated from field: string access_id = 8;
   */
  accessId: string;

  /**
   * @generated from field: optional public_api.v1.ProjectTheme project_theme = 9;
   */
  projectTheme?: ProjectTheme;
};

/**
 * Describes the message public_api.v1.UserProduct.
 * Use `create(UserProductSchema)` to create a new message.
 */
export const UserProductSchema: GenMessage<UserProduct> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 51);

/**
 * @generated from message public_api.v1.BoolResponse
 */
export type BoolResponse = Message<"public_api.v1.BoolResponse"> & {
  /**
   * @generated from oneof public_api.v1.BoolResponse.result
   */
  result: {
    /**
     * @generated from field: google.protobuf.Empty success = 1;
     */
    value: Empty;
    case: "success";
  } | {
    /**
     * @generated from field: public_api.v1.FailureMessage failure = 2;
     */
    value: FailureMessage;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message public_api.v1.BoolResponse.
 * Use `create(BoolResponseSchema)` to create a new message.
 */
export const BoolResponseSchema: GenMessage<BoolResponse> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 52);

/**
 * @generated from message public_api.v1.PushEventRequest
 */
export type PushEventRequest = Message<"public_api.v1.PushEventRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string notification_id = 2;
   */
  notificationId: string;

  /**
   * @generated from field: common.v1.NotificationEvent event = 3;
   */
  event: NotificationEvent;
};

/**
 * Describes the message public_api.v1.PushEventRequest.
 * Use `create(PushEventRequestSchema)` to create a new message.
 */
export const PushEventRequestSchema: GenMessage<PushEventRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 53);

/**
 * @generated from message public_api.v1.PushSendDeviceTokenRequest
 */
export type PushSendDeviceTokenRequest = Message<"public_api.v1.PushSendDeviceTokenRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: common.v1.PushNotificationDeviceToken payload = 2;
   */
  payload?: PushNotificationDeviceToken;

  /**
   * @generated from field: optional bool is_notification_granted = 3;
   */
  isNotificationGranted?: boolean;
};

/**
 * Describes the message public_api.v1.PushSendDeviceTokenRequest.
 * Use `create(PushSendDeviceTokenRequestSchema)` to create a new message.
 */
export const PushSendDeviceTokenRequestSchema: GenMessage<PushSendDeviceTokenRequest> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 54);

/**
 * @generated from message public_api.v1.ProjectTheme
 */
export type ProjectTheme = Message<"public_api.v1.ProjectTheme"> & {
  /**
   * @generated from field: optional string image_url = 1;
   */
  imageUrl?: string;

  /**
   * @generated from field: optional string image_dark_url = 2;
   */
  imageDarkUrl?: string;

  /**
   * @generated from field: optional string brand_color = 3;
   */
  brandColor?: string;

  /**
   * @generated from field: optional string brand_color_dark = 4;
   */
  brandColorDark?: string;
};

/**
 * Describes the message public_api.v1.ProjectTheme.
 * Use `create(ProjectThemeSchema)` to create a new message.
 */
export const ProjectThemeSchema: GenMessage<ProjectTheme> = /*@__PURE__*/
  messageDesc(file_public_v1_public_api, 55);

/**
 * @generated from enum public_api.v1.UserProductType
 */
export enum UserProductType {
  /**
   * @generated from enum value: USER_PRODUCT_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: USER_PRODUCT_TYPE_AUDIO = 1;
   */
  AUDIO = 1,

  /**
   * @generated from enum value: USER_PRODUCT_TYPE_FILE = 2;
   */
  FILE = 2,

  /**
   * @generated from enum value: USER_PRODUCT_TYPE_TICKET = 3;
   */
  TICKET = 3,
}

/**
 * Describes the enum public_api.v1.UserProductType.
 */
export const UserProductTypeSchema: GenEnum<UserProductType> = /*@__PURE__*/
  enumDesc(file_public_v1_public_api, 0);

/**
 * @generated from enum public_api.v1.FailureMessage
 */
export enum FailureMessage {
  /**
   * @generated from enum value: FAILURE_MESSAGE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: FAILURE_MESSAGE_EMAIL_NOT_FOUND = 1;
   */
  EMAIL_NOT_FOUND = 1,

  /**
   * @generated from enum value: FAILURE_MESSAGE_INCORRECT_EMAIL = 2;
   */
  INCORRECT_EMAIL = 2,

  /**
   * @generated from enum value: FAILURE_MESSAGE_INCORRECT_CODE = 3;
   */
  INCORRECT_CODE = 3,

  /**
   * @generated from enum value: FAILURE_MESSAGE_GENERATE_ACCESS_TOKEN_FAILED = 4;
   */
  GENERATE_ACCESS_TOKEN_FAILED = 4,

  /**
   * @generated from enum value: FAILURE_MESSAGE_LOGOUT_FAILED = 5;
   */
  LOGOUT_FAILED = 5,

  /**
   * @generated from enum value: FAILURE_MESSAGE_PRDUCTS_NOT_FOUND = 6;
   */
  PRDUCTS_NOT_FOUND = 6,

  /**
   * @generated from enum value: FAILURE_MESSAGE_AUDIOBOOK_NOT_FOUND = 7;
   */
  AUDIOBOOK_NOT_FOUND = 7,

  /**
   * @generated from enum value: FAILURE_MESSAGE_INCORRECT_AUDIOBOOK = 8;
   */
  INCORRECT_AUDIOBOOK = 8,

  /**
   * @generated from enum value: FAILURE_MESSAGE_UNAUTHORIZED = 9;
   */
  UNAUTHORIZED = 9,

  /**
   * @generated from enum value: FAILURE_MESSAGE_TICKET_NOT_FOUND = 10;
   */
  TICKET_NOT_FOUND = 10,
}

/**
 * Describes the enum public_api.v1.FailureMessage.
 */
export const FailureMessageSchema: GenEnum<FailureMessage> = /*@__PURE__*/
  enumDesc(file_public_v1_public_api, 1);

/**
 * @generated from enum public_api.v1.NotificationMethod
 */
export enum NotificationMethod {
  /**
   * @generated from enum value: NOTIFICATION_METHOD_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: NOTIFICATION_METHOD_EMAIL = 1;
   */
  EMAIL = 1,

  /**
   * @generated from enum value: NOTIFICATION_METHOD_SMS = 2;
   */
  SMS = 2,

  /**
   * @generated from enum value: NOTIFICATION_METHOD_PUSH = 3;
   */
  PUSH = 3,
}

/**
 * Describes the enum public_api.v1.NotificationMethod.
 */
export const NotificationMethodSchema: GenEnum<NotificationMethod> = /*@__PURE__*/
  enumDesc(file_public_v1_public_api, 2);

/**
 * @generated from service public_api.v1.PublicApiService
 */
export const PublicApiService: GenService<{
  /**
   * @generated from rpc public_api.v1.PublicApiService.GetOrder
   */
  getOrder: {
    methodKind: "unary";
    input: typeof GetOrderRequestSchema;
    output: typeof GetOrderResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.GetOrderRetryUrl
   */
  getOrderRetryUrl: {
    methodKind: "unary";
    input: typeof GetOrderRetryUrlRequestSchema;
    output: typeof GetOrderRetryUrlResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.UserPanelLogin
   */
  userPanelLogin: {
    methodKind: "unary";
    input: typeof UserPanelLoginRequestSchema;
    output: typeof UserPanelLoginResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.UserPanelLoginWithCode
   */
  userPanelLoginWithCode: {
    methodKind: "unary";
    input: typeof UserPanelLoginWithCodeRequestSchema;
    output: typeof UserPanelLoginWithCodeResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.UserPanelLogout
   */
  userPanelLogout: {
    methodKind: "unary";
    input: typeof UserPanelLogoutRequestSchema;
    output: typeof BoolResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.UserPanelDeleteAccount
   */
  userPanelDeleteAccount: {
    methodKind: "unary";
    input: typeof UserPanelDeleteAccountRequestSchema;
    output: typeof BoolResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.UserPanelGetProducts
   */
  userPanelGetProducts: {
    methodKind: "unary";
    input: typeof UserPanelGetProductsRequestSchema;
    output: typeof UserPanelGetProductsResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.UserPanelGetAudiobookDetails
   */
  userPanelGetAudiobookDetails: {
    methodKind: "unary";
    input: typeof UserPanelGetAudiobookDetailsRequestSchema;
    output: typeof UserPanelGetAudiobookDetailsResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.UserPanelGetAudiobookDetailsDownloadURLs
   */
  userPanelGetAudiobookDetailsDownloadURLs: {
    methodKind: "unary";
    input: typeof UserPanelGetAudiobookDetailsDownloadURLsRequestSchema;
    output: typeof UserPanelGetAudiobookDetailsDownloadURLsResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.UserPanelGetFileDetails
   */
  userPanelGetFileDetails: {
    methodKind: "unary";
    input: typeof UserPanelGetFileDetailsRequestSchema;
    output: typeof UserPanelGetFileDetailsResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.UserPanelGetTicketDetails
   */
  userPanelGetTicketDetails: {
    methodKind: "unary";
    input: typeof UserPanelGetTicketDetailsRequestSchema;
    output: typeof UserPanelGetTicketDetailsResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.PushSendDeviceToken
   */
  pushSendDeviceToken: {
    methodKind: "unary";
    input: typeof PushSendDeviceTokenRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.PushEvent
   */
  pushEvent: {
    methodKind: "unary";
    input: typeof PushEventRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * iOS SHOP methods
   *
   * @generated from rpc public_api.v1.PublicApiService.ShouldShopProducts
   */
  shouldShopProducts: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ShouldShopProductsResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.GetShopProducts
   */
  getShopProducts: {
    methodKind: "unary";
    input: typeof GetShopProductsRequestSchema;
    output: typeof GetShopProductsResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.DidBuyProduct
   */
  didBuyProduct: {
    methodKind: "unary";
    input: typeof DidBuyProductRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Notification settings
   *
   * @generated from rpc public_api.v1.PublicApiService.GetNotificationSettings
   */
  getNotificationSettings: {
    methodKind: "unary";
    input: typeof GetNotificationSettingsRequestSchema;
    output: typeof GetNotificationSettingsResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.GetNotificationSettingsDetails
   */
  getNotificationSettingsDetails: {
    methodKind: "unary";
    input: typeof GetNotificationSettingsDetailsRequestSchema;
    output: typeof GetNotificationSettingsDetailsResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.UpdateGlobalNotificationSettings
   */
  updateGlobalNotificationSettings: {
    methodKind: "unary";
    input: typeof UpdateGlobalNotificationSettingsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.UpdateNotificationSettings
   */
  updateNotificationSettings: {
    methodKind: "unary";
    input: typeof UpdateNotificationSettingsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Product V2 requests
   *
   * @generated from rpc public_api.v1.PublicApiService.GetAvailableCountForProduct
   */
  getAvailableCountForProduct: {
    methodKind: "unary";
    input: typeof GetAvailableCountForProductRequestSchema;
    output: typeof GetAvailableCountForProductResponseSchema;
  },
  /**
   * Checkout requests
   *
   * @generated from rpc public_api.v1.PublicApiService.IsOneClickPaymentAvailable
   */
  isOneClickPaymentAvailable: {
    methodKind: "unary";
    input: typeof IsOneClickPaymentAvailableRequestSchema;
    output: typeof IsOneClickPaymentAvailableResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.GetPreOrderDetails
   */
  getPreOrderDetails: {
    methodKind: "unary";
    input: typeof GetPreOrderDetailsRequestSchema;
    output: typeof GetPreOrderDetailsResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.ApplePayValidateMerchant
   */
  applePayValidateMerchant: {
    methodKind: "unary";
    input: typeof ApplePayValidateMerchantRequestSchema;
    output: typeof ApplePayValidateMerchantResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.AuthorizeOneClickPayment
   */
  authorizeOneClickPayment: {
    methodKind: "unary";
    input: typeof OneClickAuthorizePaymentRequestSchema;
    output: typeof OneClickAuthorizePaymentResponseSchema;
  },
  /**
   * @generated from rpc public_api.v1.PublicApiService.NotifyUserAboutProductAvailability
   */
  notifyUserAboutProductAvailability: {
    methodKind: "unary";
    input: typeof NotifyUserAboutProductAvailabilityRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_public_v1_public_api, 0);

